export default __webpack_public_path__ + "static/media/bg_voucher.a8c73229.png";